const CurrentClass8th = [
  { label: "9th", value: "9" },
  { label: "10th", value: "10" },
];

export default CurrentClass8th;
